module.exports = __webpack_public_path__ + "img/bg_01.9f18716c.png";